import ShareableLinkNodePreview from './ShareableLinkNodePreview.component';

export default ShareableLinkNodePreview;